// hodnocení
$(window).on('load', function() {
  $('.votes-wrap.admin-response .vote-pic img').hide()
  $('.votes-wrap.admin-response .vote-pic > img').hide()
  $('.votes-wrap.admin-response .span.vote-initials').hide()
  $(
    '<img src="https://www.vyspimese.cz/user/documents/upload/temp/icon-jiri-dostal.png" />'
  ).appendTo('.votes-wrap.admin-response .vote-pic')
  $('span.vote-admin-response').html('za Vyspimese.cz, Jiří Dostal')
})

$(window).on('load', function() {
  $('.hodnoceni-2 .vote-pic > img').hide()
  $('.hodnoceni-2 .span.vote-initials').hide()
  $(
    '<img src="https://www.vyspimese.cz/user/documents/upload/temp/icon-jiri-dostal.png" />'
  ).appendTo('.votes-wrap.admin-response .vote-pic')
})

// homepage
window.onload = function() {
  if ($('body').hasClass('id-1')) {
    $('.small__category').insertAfter('.home-box')
    $('.production__wrapper').insertAfter('.small__category')
    $('.text__wrapper').insertAfter('.list-blog')
    $(
      '<a class="blog-more" href="https://blog.vyspimese.cz/" target="_blank">Zobrazit všechny články</a>'
    ).insertAfter('.list-blog')

    // slider
    $('.logotyp__wrapper--list').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        }
      ]
    })

    // hodnocení
    if ($('.rating__wrapper').length > 0) {
      $.get(
        '/cache/hodnoceni-obchodu/',
        function(data) {
          var response = $($.parseHTML(data))
          var contentInner = response.find('.content-inner')
          var votesWrap = contentInner.find('.votes-wrap')
          var rateAverageInner = contentInner.find('.rate-average-inner')

          // Vyber první tři .vote-wrap prvky
          var limitedVotesWrap = votesWrap.slice(0, 3)

          // Vytvoř nový prvek, který bude obsahovat pouze tyto tři prvky
          var newVotesWrap = $('<div class="votes-wrap"></div>').append(limitedVotesWrap)

          // Zapiš do správného elementu
          $('.rating__wrapper--detail.rating-link').html(newVotesWrap)

          // Vlož rateAverageInner do rating-detail
          $('.rating-detail').html(rateAverageInner)
        },
        'html'
      )
    }

    setTimeout(function() {
      $('.hodnoceni-2 .vote-pic img').each(function() {
        $(this).attr('src', $(this).attr('data-src'))
      })
    }, 1500)
  }
}

$(
  '<div class=\'koder\'><div>Nakodoval: <a href=\'https://shoptet-koder.cz/\' target=\'_blank\'>Štefan Mazáň</a></div></div>'
).insertAfter('#signature a.title')

// mobile
// homepage
if ($('body').hasClass('id-1') && window.innerWidth <= 768) {
  $('<h2 class="title">To nejlepší z kategorií</h2>').insertAfter('main .banners-row .col-sm-4')
}
